(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dx-campaign-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const slides = Array.from(root.querySelectorAll('[data-dx-campaign-slide]'));
      if (slides.length < 2) return;
      const dots = Array.from(root.querySelectorAll('[data-dx-campaign-dot]'));
      const previous = root.querySelector('[data-dx-campaign-previous]');
      const next = root.querySelector('[data-dx-campaign-next]');
      const pause = root.querySelector('[data-dx-campaign-pause]');
      const pauseText = root.querySelector('[data-dx-campaign-pause-text]');
      const status = root.querySelector('[data-dx-campaign-status]');
      const interval = Math.max(Number(root.dataset.interval) || 5000, 3000);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0;
      let timer;
      let userPaused = false;
      let interactionPaused = false;
      let inView = true;
      let visibilityObserver;
      const events = new AbortController();
      const listen = (node, type, callback) => node?.addEventListener(type, callback, { signal: events.signal });

      const announce = () => {
        if (!status) return;
        status.textContent = root.dataset.statusTemplate.replace('__CURRENT__', String(current + 1));
      };

      const schedule = () => {
        window.clearTimeout(timer);
        if (root.dataset.autoplay !== 'true' || userPaused || interactionPaused || !inView || document.hidden || reducedMotion.matches) return;
        timer = window.setTimeout(() => {
          show(current + 1, false);
        }, interval);
      };

      const show = (index, shouldAnnounce = true) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
        if (shouldAnnounce) announce();
        schedule();
      };

      const updatePause = () => {
        if (!pause) return;
        const label = userPaused ? pause.dataset.playLabel : pause.dataset.pauseLabel;
        pause.setAttribute('aria-pressed', String(userPaused));
        if (pauseText) pauseText.textContent = label;
        schedule();
      };

      listen(previous, 'click', () => show(current - 1));
      listen(next, 'click', () => show(current + 1));
      dots.forEach((dot) => listen(dot, 'click', () => show(Number(dot.dataset.slideIndex))));
      listen(pause, 'click', () => {
        userPaused = !userPaused;
        updatePause();
      });
      listen(root, 'pointerenter', () => {
        interactionPaused = true;
        schedule();
      });
      listen(root, 'pointerleave', () => {
        interactionPaused = false;
        schedule();
      });
      listen(root, 'focusin', () => {
        interactionPaused = true;
        schedule();
      });
      listen(root, 'focusout', (event) => {
        if (root.contains(event.relatedTarget)) return;
        interactionPaused = false;
        schedule();
      });
      listen(document, 'visibilitychange', schedule);
      listen(reducedMotion, 'change', schedule);

      if ('IntersectionObserver' in window) {
        visibilityObserver = new IntersectionObserver((entries) => {
          inView = entries[0]?.isIntersecting ?? true;
          schedule();
        }, { threshold: 0.2 });
        visibilityObserver.observe(root);
      }

      // Editor section replacement must release observers, timers and global listeners.
      root.dxCampaignDestroy = () => {
        window.clearTimeout(timer);
        events.abort();
        visibilityObserver?.disconnect();
        delete root.dataset.initialized;
        delete root.dxCampaignShow;
        delete root.dxCampaignPause;
        delete root.dxCampaignDestroy;
      };
      listen(root, 'keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
      });
      root.dxCampaignShow = show;
      root.dxCampaignPause = () => {
        userPaused = true;
        updatePause();
      };
      show(0, false);
    };

    document.querySelectorAll('[data-dx-campaign]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches?.('[data-dx-campaign]')) initialize(event.target);
      event.target.querySelectorAll?.('[data-dx-campaign]').forEach(initialize);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.dxCampaignDestroy?.();
      event.target.querySelectorAll?.('[data-dx-campaign]').forEach((root) => root.dxCampaignDestroy?.());
    });
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest?.('[data-dx-campaign-slide]');
      const root = slide?.closest('[data-dx-campaign]');
      if (!slide || !root?.dxCampaignShow) return;
      root.dxCampaignShow(Number(slide.dataset.slideIndex));
      root.dxCampaignPause?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dx-car-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dailyx-car-product')) {
    customElements.define('dailyx-car-product', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.setAttribute('data-enhanced', '');
        const slides = [...this.querySelectorAll('[data-dc-slide]')];
        const thumbs = [...this.querySelectorAll('[data-dc-thumb]')];
        const dialog = this.querySelector('[data-dc-dialog]');
        const showSlide = (id) => {
          slides.forEach((slide) => {
            if (slide.id !== id && !slide.hidden) {
              slide.querySelectorAll('video').forEach(video => video.pause());
              slide.querySelectorAll('iframe').forEach(frame => { frame.src = frame.src; });
            }
            slide.hidden = slide.id !== id;
          });
          thumbs.forEach(thumb => thumb.setAttribute('aria-current', String(thumb.dataset.dcThumb === id)));
        };
        this.addEventListener('click', event => {
          const thumb = event.target.closest('[data-dc-thumb]');
          if (thumb) showSlide(thumb.dataset.dcThumb);
          const zoom = event.target.closest('[data-dc-zoom]');
          if (zoom && typeof dialog?.showModal === 'function') {
            event.preventDefault();
            this.zoomTrigger = zoom;
            const image = dialog.querySelector('[data-dc-full-image]');
            image.src = zoom.href;
            image.alt = zoom.querySelector('img')?.alt || '';
            dialog.showModal();
          }
          if (event.target.closest('[data-dc-close]') || event.target === dialog) dialog.close();
        }, { signal });
        dialog?.addEventListener('close', () => this.zoomTrigger?.focus({ preventScroll: true }), { signal });
        const stage = this.querySelector('[data-dc-stage]');
        stage?.addEventListener('touchstart', event => { this.touchStart = {x:event.touches[0].clientX,y:event.touches[0].clientY}; }, {passive:true,signal});
        stage?.addEventListener('touchend', event => {
          if (!this.touchStart || slides.length < 2 || event.target.closest('video, iframe, model-viewer')) return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          const current = slides.findIndex(slide => !slide.hidden);
          showSlide(slides[(current + (dx < 0 ? 1 : -1) + slides.length) % slides.length].id);
        }, {passive:true,signal});
        const purchase = this.querySelector('[data-dc-purchase]');
        const sticky = this.querySelector('[data-dc-sticky]');
        if (purchase && sticky && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            const entry = entries[0];
            sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
          }, {threshold:0});
          this.observer.observe(purchase);
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
